import React from 'react';
import { Button, Result, Spin } from 'antd';
import useIncidentsAccess from '../../hooks/useIncidentsAccess';

/**
 * Protege el centro de incidentes. La decisión es de la API (permiso de la persona o de
 * su rol); esto solo evita mostrar una pantalla que respondería 403. Mientras se
 * pregunta se ve un indicador, y si no se pudo comprobar se ofrece reintentar en vez de
 * decir «sin acceso» por un fallo de red.
 */
const RequireIncidentsAccess = ({ fallback = null, children }) => {
  const { status, retry } = useIncidentsAccess();

  if (status === 'loading') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin />
      </div>
    );
  }

  if (status === 'error') {
    return (
      fallback || (
        <Result
          status="warning"
          title="No pudimos comprobar tu acceso"
          subTitle="Intenta de nuevo en unos segundos."
          extra={
            <Button type="primary" onClick={retry}>
              Reintentar
            </Button>
          }
        />
      )
    );
  }

  if (status !== 'allowed') {
    return (
      fallback || (
        <Result
          status="403"
          title="Sin acceso"
          subTitle="No tienes el permiso para ver el centro de incidentes. Pídele a un administrador que lo active, en Usuarios, en Permisos > Plataforma > Incidentes."
        />
      )
    );
  }

  return children;
};

export default RequireIncidentsAccess;
